import { render, staticRenderFns } from "./RadioButtonBuilder.vue?vue&type=template&id=72a75cac&scoped=true"
import script from "./RadioButtonBuilder.vue?vue&type=script&lang=js"
export * from "./RadioButtonBuilder.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a75cac",
  null
  
)

export default component.exports